import { defineMessages } from 'react-intl';

const messages = defineMessages({
  modalHeader: {
    description: 'Header in modal to accept invitation to connect to marketplace.',
    defaultMessage: 'Connect to Marketplace',
    id: 'NV7b2e',
  },
  modalHeaderNotActive: {
    description: 'Header in modal letting the user know the invitation is no longer active.',
    defaultMessage: 'Invitation No Longer Active',
    id: 'kLUMEv',
  },
  modalHeaderError: {
    description: 'Title for modal to be shown when an error occurred gathering the invitation status.',
    defaultMessage: 'Error Gathering Invitation Status',
    id: 'lkAXOg',
  },
  modalErrorMessage: {
    description: 'message shown when an error occurred gathering the invitation status.',
    defaultMessage: 'An error occurred while processing your request. Please try again.',
    id: 'MBBWbf',
  },
  connectToMarketPlaceBody: {
    description: 'Message describing who invited the user to connect to their Marketplace.',
    defaultMessage:
      '<b>{marketplaceName}</b> has invited you to connect your ShipStation account <b>{vendorName}</b> (email: <b>{vendorEmail}</b>) to theirs.',
    id: '1SyCIq',
  },
  connectToMarketPlaceBodyConformation: {
    description: 'Letting user know what will happen once a connection is established.',
    defaultMessage:
      'If you approve this connection, <b>{marketplaceName}</b> will appear as one of your configured Stores, and they can delegate specific orders for you to fulfill via ShipStation.',
    id: '4kkw2s',
  },
  inviteNotActiveBody: {
    description: 'Message describing the invite is no longer active and cannot be accepted.',
    defaultMessage:
      'The invitation to connect to {marketplaceName} has expired. If this was unexpected, contact the merchant to request a new invitation.',
    id: 'ZazDk6',
  },
  confirmCheckboxLabel: {
    description: 'Label letting the user know they must confirm the following agreement.',
    defaultMessage: 'Confirm Agreement',
    id: 'Svg9p5',
  },
  confirmCheckboxText: {
    description: 'User Agreement needed to approve connection.',
    defaultMessage: 'I understand this agreement and approve this connection.',
    id: 'b1jTLY',
  },
  cancelButton: {
    description: 'Cancel Invitation button will reject this invitation and close the modal',
    defaultMessage: 'Cancel',
    id: '7bkUrd',
  },
  connectButton: {
    description: 'Connect button',
    defaultMessage: 'Connect',
    id: 'dxhAGR',
  },
  closeButton: {
    description: 'Close Modal button',
    defaultMessage: 'Close',
    id: 'hH6JcF',
  },
  establishingConnectionTitle: {
    description: 'Title informing the user the connection request is being processed',
    defaultMessage: 'Marketplace Connection Establishing',
    id: 'A85cIF',
  },
  establishingConnectionMessage: {
    description: 'Message indicating the connection is being established',
    defaultMessage: 'Establishing connection with {marketplaceName}. Please wait...',
    id: 'i9Zf3J',
  },
  succesfulConnectionTitle: {
    description: 'Title informing the user the connection was successfully established',
    defaultMessage: 'Marketplace successfully connected ',
    id: 'KglXkJ',
  },
  succesfulConnectionMessage: {
    description: 'Message indicating the connection was successfully established',
    defaultMessage:
      'You are now connected with {marketplaceName}. Work directly with your marketplace to configure any additional settings. ',
    id: 'fGgrwQ',
  },
  connectionCancelledTitle: {
    description: 'Title for message informing user that connection was cancelled',
    defaultMessage: 'Marketplace Connection Cancelled',
    id: 'aztEE3',
  },
  connectionCancelledMessage: {
    description: 'message informing user that connection was cancelled by them clicking the cancel button',
    defaultMessage: 'If this was in error, click the link in your connection invite to try again.',
    id: 'xuwAAm',
  },
  failedConnectionTitle: {
    description: 'Title for message informing user that connection request failed',
    defaultMessage: 'Marketplace Connection Error',
    id: 'QrNgVq',
  },
  failedConnectionMessage: {
    description: 'message informing user that connection request failed',
    defaultMessage: 'System error on our side. Please click the link in your email again.',
    id: 'hyehVP',
  },
  selfInviteErrorTitle: {
    description:
      'Title for message informing the user that they are trying to accept an invite from the same account which the invite was sent',
    defaultMessage: 'Marketplace Connection Error',
    id: 'keX8wP',
  },
  selfInviteErrorMessage: {
    description: 'message informing the user that they are trying to accept an invite from the same account which the invite was sent',
    defaultMessage:
      'The same account used to send an invite cannot be used to accept that invite. Please check the account you are using to accept the invite and try again.',
    id: 'WK0Vnw',
  },
  inviteNotFoundErrorTitle: {
    description: 'Title for message informing user that the invitation was not found',
    defaultMessage: 'Invitation Not Found',
    id: 'XT2OJN',
  },
  inviteNotFoundErrorMessage: {
    description: 'Message informing user that the invitation was not found',
    defaultMessage: 'The invitation you are trying to accept could not be found. Please check the link in your email and try again.',
    id: 'kyzueb',
  },
  inviteNotPendingErrorTitle: {
    description: 'Title for message informing user that the invitation is not pending',
    defaultMessage: 'Invitation Not Pending',
    id: 'CRBq1V',
  },
  inviteNotPendingErrorMessage: {
    description: 'Message informing user that the invitation is not pending',
    defaultMessage:
      'The invitation you are trying to accept is no longer pending. Please check the status of your invitation and try again.',
    id: 'wExDev',
  },
});

export default messages;
